import axios from 'axios';
import { TAddInfoData } from '../types/ExtInfoBox';

export const getConstructionList = (
  progress_ids: number[],
  assignee: number,
  construct_sub: string,
  customer_name: string,
  completion_date_Start: string,
  completion_date_End: string,
  contract_date_Start: string,
  contract_date_End: string,
  Exp_Contract_start_date: string,
  Exp_Contract_end_date: string,
  construction_number: string,
  estimate_number: string,
  prefecture_name: string,
  address: string,
  current_page: number,
  display_limit: number,
  addInfoData?: TAddInfoData
) => {
  let progress_query = '';
  progress_ids.forEach(id => {
    progress_query += `progress_ids=${id}&`;
  });
  let url =
    '/api/v1/constructions?' +
    `${progress_query}` +
    `assignee=${assignee}&` +
    `construct_sub=${construct_sub}&` +
    `customer_name=${customer_name}&` +
    `completion_start_date=${completion_date_Start}&` +
    `completion_end_date=${completion_date_End}&` +
    `start_date=${contract_date_Start}&` +
    `end_date=${contract_date_End}&` +
    `exp_start_date=${Exp_Contract_start_date}&` +
    `exp_end_date=${Exp_Contract_end_date}&` +
    `code=${construction_number}&` +
    `estimate_code=${estimate_number}&` +
    `prefecture_name=${prefecture_name}&` +
    `address=${address}&` +
    `page=${current_page}&` +
    `display_limit=${display_limit}`;

  // 追加情報が存在する場合
  if (addInfoData) {
    const queryString = JSON.stringify(addInfoData);
    // 追加パラメーターフラグを1にする
    url = url + '&ext_info_search_flg=1&ext_info_params=' + queryString;
  } else {
    // 追加パラメーターフラグを0にする
    url = url + '&ext_info_search_flg=0';
  }

  return axios
    .get(url, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 工事一覧(IDとnameのみ)取得
 * @returns
 */
export const getConstructions = () => {
  return axios
    .get('/api/v1/get/constructions?hasProcessFlag=true', {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const deleteConstructionList = (constructs_list: any) => {
  return axios
    .post(
      `/api/v1/delete/constructions`,
      {
        constructs_list: constructs_list
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const saveConstruction = (
  id: number,
  code: string,
  construct_type: number,
  renew_status: number,
  building_scale: number | undefined,
  name: string,
  site_prefecture: number | undefined,
  site_address1: string,
  site_address2: string,
  site_address3: string,
  remarks: string,
  contractor_prefecture: number | undefined,
  contractor_address1: string,
  contractor_address2: string,
  contractor_address3: string,
  contractor_name: string,
  contractor_tel: string,
  progress_status: number,
  planned_cost: number | undefined,
  planned_days: number | undefined,
  planned_gross_profit: number | undefined,
  contract_date: string,
  start_date: string,
  end_date: string,
  billing_date: string,
  payment_date: string,
  failure_date: string,
  inspection_date: string,
  contract_tax_rate: number | undefined,
  expected_contract_date: string,
  expected_start_date: string,
  expected_end_date: string,
  expected_payment_date: string,
  small_expenses: number | '',
  assignee_list: any,
  assignee_outside_partner_list: any,
  company_name: string,
  company_code: string,
  company_postal_code: string,
  company_address: string,
  company_phone_number: string,
  company_fax_number: string,
  latitude: number,
  longitude: number,
  is_marker_checked: boolean,
  possible_time: string,
  park_space: string,
  smoking_rule: string,
  important_others: string,
  janitor_name: string,
  janitor_phone_number: string,
  janitor_fax_number: string,
  janitor_work_hours: string,
  janitor_others: string,
  small_expense_items: any
) => {
  return axios
    .post(
      `/api/v1/constructions/${id}`,
      {
        code,
        construct_type,
        renew_status,
        building_scale,
        name,
        site_prefecture,
        site_address1,
        site_address2,
        site_address3,
        remarks,
        contractor_prefecture,
        contractor_address1,
        contractor_address2,
        contractor_address3,
        contractor_name,
        contractor_tel,
        progress_status,
        planned_cost,
        planned_days,
        planned_gross_profit,
        contract_date,
        start_date,
        end_date,
        billing_date,
        payment_date,
        failure_date,
        inspection_date,
        contract_tax_rate,
        expected_contract_date,
        expected_start_date,
        expected_end_date,
        expected_payment_date,
        small_expenses,
        assignee_list,
        assignee_outside_partner_list,
        company_name,
        company_code,
        company_postal_code,
        company_address,
        company_phone_number,
        company_fax_number,
        latitude,
        longitude,
        is_marker_checked,
        possible_time,
        park_space,
        smoking_rule,
        important_others,
        janitor_name,
        janitor_phone_number,
        janitor_fax_number,
        janitor_work_hours,
        janitor_others,
        small_expense_items
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const updateProgressStatus = (id: number, progress_status: number) => {
  return axios
    .put(
      `/api/v1/constructions/status/${id}`, // URL修正
      {
        progress_status
      },
      {
        headers: {
          'Content-Type': 'application/json',
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      console.log(err);
      if (err.response && err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getConstructionTypes = () => {
  return axios
    .get(`/api/v1/get/construct/types`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getScaleList = () => {
  return axios
    .get(`/api/v1/get/scales`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getPrefectureList = () => {
  return axios
    .get(`/api/get/prefectures`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getAssigneeRoles = () => {
  return axios
    .get(`/api/v1/get/assignee/roles`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getConstructionDetails = (id: number) => {
  return axios
    .get(`/api/v1/constructions/${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const updateConstruction = (
  id: number,
  code: string,
  construct_type: number,
  renew_status: number,
  building_scale: number | undefined,
  name: string,
  site_prefecture: number | undefined,
  site_address1: string,
  site_address2: string,
  site_address3: string,
  remarks: string,
  contractor_prefecture: number | undefined,
  contractor_address1: string,
  contractor_address2: string,
  contractor_address3: string,
  contractor_name: string,
  contractor_tel: string,
  progress_status: number,
  planned_cost: number | undefined,
  planned_days: number | undefined,
  planned_gross_profit: number | undefined,
  contract_date: string,
  start_date: string,
  end_date: string,
  billing_date: string,
  payment_date: string,
  failure_date: string,
  inspection_date: string,
  contract_tax_rate: number | undefined,
  expected_contract_date: string,
  expected_start_date: string,
  expected_end_date: string,
  expected_payment_date: string,
  small_expenses: number,
  assignee_list: any,
  assignee_outside_partner_list: any,
  company_name: string,
  company_code: string,
  company_postal_code: string,
  company_address: string,
  company_phone_number: string,
  company_fax_number: string,
  latitude: number,
  longitude: number,
  is_marker_checked: boolean,
  possible_time: string,
  park_space: string,
  smoking_rule: string,
  important_others: string,
  janitor_name: string,
  janitor_phone_number: string,
  janitor_fax_number: string,
  janitor_work_hours: string,
  janitor_others: string,
  small_expense_items: any
) => {
  return axios
    .put(
      `/api/v1/constructions/${id}`,
      {
        code,
        construct_type,
        renew_status,
        building_scale,
        name,
        site_prefecture,
        site_address1,
        site_address2,
        site_address3,
        remarks,
        contractor_prefecture,
        contractor_address1,
        contractor_address2,
        contractor_address3,
        contractor_name,
        contractor_tel,
        progress_status,
        planned_cost,
        planned_days,
        planned_gross_profit,
        contract_date,
        start_date,
        end_date,
        billing_date,
        payment_date,
        failure_date,
        inspection_date,
        contract_tax_rate,
        expected_contract_date,
        expected_start_date,
        expected_end_date,
        expected_payment_date,
        small_expenses,
        assignee_list,
        assignee_outside_partner_list,
        company_name,
        company_code,
        company_postal_code,
        company_address,
        company_phone_number,
        company_fax_number,
        latitude,
        longitude,
        is_marker_checked,
        possible_time,
        park_space,
        smoking_rule,
        important_others,
        janitor_name,
        janitor_phone_number,
        janitor_fax_number,
        janitor_work_hours,
        janitor_others,
        small_expense_items
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getConstructInvoices = (
  id: number,
  sort_field?: string,
  sort_direction?: string
) => {
  return axios
    .get(`/api/v1/construct/invoices/${id}`, {
      headers: {
        withCredentials: true
      },
      params: {
        sort_field,
        sort_direction
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getConstructContracts = (id: number) => {
  return axios
    .get(`/api/v1/construct/contracts/${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getConstructMerchandise = (
  id: number,
  sort_field?: string,
  sort_direction?: string
) => {
  return axios
    .get(`/api/v1/construct/merchandise/orders/${id}`, {
      headers: {
        withCredentials: true
      },
      params: {
        sort_field,
        sort_direction
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getConstructOutSources = (
  id: number,
  sort_field?: string,
  sort_direction?: string
) => {
  return axios
    .get(`/api/v1/construct/outsources/${id}`, {
      headers: {
        withCredentials: true
      },
      params: {
        sort_field,
        sort_direction
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getConstructSiteContacts = (
  id: number,
  sort_field?: string,
  sort_direction?: string
) => {
  return axios
    .get(`/api/v1/construct/site_contacts/${id}`, {
      headers: {
        withCredentials: true
      },
      params: {
        sort_field,
        sort_direction
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getConstructionClientDetails = (id: number) => {
  return axios
    .get(`/api/v1/get/customer/data/${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getTeamSummaryList = (
  progress: number,
  start_date_year: number,
  start_date_month: number,
  end_date_year: number,
  end_date_month: number
) => {
  return axios
    .get(
      `/api/v1/construction/teamsummary?progress=${progress}&start_date_year=${start_date_year}&start_date_month=${start_date_month}&end_date_year=${end_date_year}&end_date_month=${end_date_month}`,
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
//sort_value: any,
export const getPersonalSummaryList = (
  progress: number,
  start_date_year: number,
  start_date_month: number,
  end_date_year: number,
  end_date_month: number
) => {
  return axios
    .get(
      `/api/v1/construction/personalsummary?progress=${progress}&start_date_year=${start_date_year}&start_date_month=${start_date_month}&end_date_year=${end_date_year}&end_date_month=${end_date_month}`,
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getConstructionSummaryList = (
  column_name: String,
  sorting_order: String,
  progress: number,
  start_date_year: number,
  start_date_month: number,
  end_date_year: number,
  end_date_month: number
) => {
  return axios
    .get(
      `/api/v1/construction/summary?column_name=${column_name}&sorting_order=${sorting_order}&progress=${progress}&start_date_year=${start_date_year}&start_date_month=${start_date_month}&end_date_year=${end_date_year}&end_date_month=${end_date_month}`,
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getIndividualConstructionSummaryList = (
  user_id: any,
  start_date_year: number,
  start_date_month: number,
  end_date_year: number,
  end_date_month: number
) => {
  console.log(start_date_month);
  console.log(end_date_month);
  return axios
    .get(`/api/v1/individual/construction/summary/${user_id}`, {
      params: {
        start_date_year,
        start_date_month,
        end_date_year,
        end_date_month
      },
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
export const getExportConstructionItems = (
  selected_columns: any,
  progress_ids: number[],
  assignee: number,
  construct_sub: string,
  customer_name: string,
  completion_date_Start: string,
  completion_date_End: string,
  contract_date_start: string,
  contract_date_end: string,
  expected_contract_date_start: string,
  expected_contract_date_end: string,
  construction_number: string,
  prefecture_name: string,
  address: string,
  addInfoData?: TAddInfoData
) => {
  let progress_query = '';
  progress_ids.forEach(id => {
    progress_query += `progress_ids=${id}&`;
  });
  let url =
    '/api/v1/export/constructions/list?' +
    `${progress_query}` +
    `assignee=${assignee}&` +
    `construct_sub=${construct_sub}&` +
    `customer_name=${customer_name}&` +
    `completion_start_date=${completion_date_Start}&` +
    `completion_end_date=${completion_date_End}&` +
    `contract_date_start=${contract_date_start}&` +
    `contract_date_end=${contract_date_end}&` +
    `expected_contract_date_start=${expected_contract_date_start}&` +
    `expected_contract_date_end=${expected_contract_date_end}&` +
    `code=${construction_number}&` +
    `prefecture_name=${prefecture_name}&` +
    `address=${address}`;

  // 追加情報が存在する場合
  if (addInfoData) {
    const queryString = JSON.stringify(addInfoData);
    // 追加パラメーターフラグを1にし、クエリ文字列を追加する
    url +=
      '&ext_info_search_flg=1&ext_info_params=' +
      encodeURIComponent(queryString);
  } else {
    // 追加パラメーターフラグを0にする
    url += '&ext_info_search_flg=0';
  }

  return axios
    .post(
      url,
      {
        selected_columns
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
export const getAllConstructionList = () => {
  return axios
    .get(`/api/get/all/constructions/list`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 現場画像を取得する処理
 * @param construct_id
 * @returns
 */
export const getConstructionSiteImgById = (construct_id: number) => {
  return axios
    .get(`/api/v1/constructions/site_img/${construct_id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response;
    })
    .catch(err => {
      console.log('エラーメッセージ', err);
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const updateEndDate = (construct_id: number, end_date: Date | null) => {
  return axios
    .put(
      `/api/v1/constructions/${construct_id}/update_end_date`,
      {
        end_date
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 現場画像を登録する
 * @param construct_id
 * @param file
 * @returns
 */
export const postConstructionSiteImgById = (
  construct_id: number,
  file_obj: any
) => {
  return axios
    .post(`/api/v1/constructions/site_img/${construct_id}`, file_obj, {
      headers: {
        withCredentials: true,
        'Content-Type': 'multipart/form-data'
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 現場画像を削除する処理
 * @param construct_id
 * @param file
 * @returns
 */
export const deleteConstructionSiteImgById = (construct_id: number) => {
  return axios
    .delete(`/api/v1/constructions/site_img/${construct_id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getOutsidePartnersById = (constructId: number) => {
  return axios
    .get(`/api/get/outside_partners/${constructId}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(res => {
      return res;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
